import { render, staticRenderFns } from "./categoryTrending.vue?vue&type=template&id=00ea80a6&scoped=true&"
import script from "./categoryTrending.vue?vue&type=script&lang=js&"
export * from "./categoryTrending.vue?vue&type=script&lang=js&"
import style0 from "./categoryTrending.vue?vue&type=style&index=0&id=00ea80a6&scoped=true&lang=css&"
import style1 from "./categoryTrending.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ea80a6",
  null
  
)

export default component.exports